import PropTypes from "prop-types";
import {
  CircularProgress,
  Box,
  Paper,
  Grid,
  Button,
  IconButton,
  Typography,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
// import classNames from "classnames";
import {
  daysOfWeek,
  createDaysForCurrentMonth,
  createDaysForNextMonth,
  createDaysForPreviousMonth,
  isWeekendDay,
  getMonthDropdownOptions,
  getYearDropdownOptions,
  getMonthName,
} from "./helpers";

CalendarPublic.propTypes = {
  yearAndMonth: PropTypes.arrayOf(PropTypes.number).isRequired, // e.g. [2021, 6] for June 2021
  onYearAndMonthChange: PropTypes.func.isRequired,
  renderDay: PropTypes.func,
};
export function CalendarPublic({
  yearAndMonth = [2021, 6],
  onYearAndMonthChange,
  renderDay = () => null,
}) {
  const [year, month] = yearAndMonth;

  let currentMonthDays = createDaysForCurrentMonth(year, month);
  let previousMonthDays = createDaysForPreviousMonth(
    year,
    month,
    currentMonthDays
  );
  let nextMonthDays = createDaysForNextMonth(year, month, currentMonthDays);
  let calendarGridDayObjects = [
    ...previousMonthDays,
    ...currentMonthDays,
    ...nextMonthDays,
  ];

  const handleMonthNavBackButtonClick = () => {
    let nextYear = year;
    let nextMonth = month - 1;
    if (nextMonth === 0) {
      nextMonth = 12;
      nextYear = year - 1;
    }
    onYearAndMonthChange([nextYear, nextMonth]);
  };

  const handleMonthNavForwardButtonClick = () => {
    let nextYear = year;
    let nextMonth = month + 1;
    if (nextMonth === 13) {
      nextMonth = 1;
      nextYear = year + 1;
    }
    onYearAndMonthChange([nextYear, nextMonth]);
  };

  const handleMonthSelect = (evt) => {
    let nextYear = year;
    let nextMonth = parseInt(evt.target.value, 10);
    onYearAndMonthChange([nextYear, nextMonth]);
  };

  const handleYearSelect = (evt) => {
    let nextMonth = month;
    let nextYear = parseInt(evt.target.value, 10);
    onYearAndMonthChange([nextYear, nextMonth]);
  };

  return (
    <div className="calendar-root">
      <div className="navigation-header">
        <Grid container columnSpacing={1} sx={{ mb: 2 }} alignItems="center">
          <Grid item>
            <Typography variant="h5">
              {getMonthName(month)}, {year} &nbsp;&nbsp;&nbsp;
            </Typography>
          </Grid>
          <Grid item>
            <IconButton onClick={handleMonthNavBackButtonClick}>
              <ArrowBackIosIcon />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton
              onClick={handleMonthNavForwardButtonClick}
              // variant="outlined"
              // size="large"
            >
              <ArrowForwardIosIcon />
            </IconButton>
          </Grid>
        </Grid>
      </div>
      <div className="days-of-week">
        {daysOfWeek.map((day, index) => (
          <div key={day} className="day-of-week-header-cell">
            {day}
          </div>
        ))}
      </div>
      <div className="days-grid">
        {calendarGridDayObjects.map((day) => (
          <div
            key={day.dateString}
            className="day-grid-item-container"
            // , {
            //   "weekend-day": isWeekendDay(day.dateString),
            //   "current-month": day.isCurrentMonth,
            // })}
          >
            <div className="day-content-wrapper">{renderDay(day)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

CalendarPublicDayHeader.propTypes = {
  calendarDayObject: PropTypes.object.isRequired,
};
export function CalendarPublicDayHeader({
  calendarDayObject,
  isLoading,
  onClick,
}) {
  return (
    <div className="day-grid-item-header" onClick={onClick}>
      {calendarDayObject.dayOfMonth}
      {isLoading ? " [loading...]" : null}
    </div>
  );
}

export default CalendarPublic;
